<template>
	<module class="g-foot" flex="flex-between-center">
		<div class="info">
			<p><b>主办单位：</b>淮阳区行政审批和政务信息管理局</p>
			<p><b>地址：</b>周口市淮阳区腾飞路与工业二路交叉口</p>
			<p><b>联系电话：</b>0394-2630088</p>
			<p><b>邮编：</b>466000</p>
			<p><a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备19010525号-1</a></p>
		</div>
		<div class="qrcode flex">
			<div class="item">
				<img src="@/assets/image/qrcode_1.jpg" alt="">
				<p>淮阳区政务服务公众号</p>
			</div>
			<div class="item">
				<img src="@/assets/image/qrcode_2.png" alt="">
				<p>微信扫码咨询客服</p>
			</div>
		</div>
	</module>
</template>

<script>
	export default {
		data() {
			return {
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.g-foot {
		border-top: 1px solid #DBE9FE;
		padding: 30px 0;
		background: #EFF6FF !important;

		.info {
			p {
				line-height: 30px;
				font-size: 14px;
				color: #444;
			}
			
			a:hover {
				text-decoration: underline;
			}
		}
		
		.qrcode {
			gap: 20px;
			
			.item {
				img {
					width: 140px;
					height: 140px;
				}
				
				p {
					margin-top: 14px;
					font-size: 13px;
					text-align: center;
					color: #666;
				}
			}
		}
	}
</style>
